import { render, staticRenderFns } from "./DynamicFieldsList.vue?vue&type=template&id=50055b0b&scoped=true&"
import script from "./DynamicFieldsList.vue?vue&type=script&lang=ts&"
export * from "./DynamicFieldsList.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicFieldsList.vue?vue&type=style&index=0&id=50055b0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50055b0b",
  null
  
)

export default component.exports